import * as React from 'react';

interface Props {
  text?: string
}

class MultilineText extends React.Component<Props> {

  public render() {
    if (!this.props.text) {
      return null;
    }

    const lines = this.props.text.split('\n');

    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 ? <br/> : undefined}
      </React.Fragment>
    ));
  }

}

export default MultilineText;
